(function () {

    class AblyWebSocketStrategy {
        constructor() {

            console.log("new AblyWebSocketStrategy")
            this.realtimeHandle = null;
            this.connectResolve = null;
            this.conenctReject = null;
            this.connected = new Promise((resolve, reject) => {
                console.log("AblyWebSocketStrategy Connected")
                this.connectResolve = resolve;
                this.conenctReject = reject;
            });
        }

        async injectPayload(src) {
            return new Promise((resolve, reject) => {
                var head = document.getElementsByTagName("head")[0];
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.onload = function () {
                    resolve();
                };
                script.onerror = function (e) {
                    reject(e);
                };
                script.src = src;
                head.appendChild(script);
            });
        }

        async initialize(settings) {
            // inject ably script.

            try {
                await this.injectPayload(settings.libary);
            } catch (e) {
                return Promise.reject(e);
            }

            this.realtimeHandle = new Ably.Realtime({
                authUrl: settings.authUrl,
            });

            this.realtimeHandle.connection.once("connected", () => {
                this.connectResolve(this.realtimeHandle);
            });

            return Promise.resolve();
        }

        /** @return Promise<AblyRealtimeHandle> */
        getConnection () {
            return this.connected
        }
    }

    touchKit.WebSocketManager.registerStrategy("AblyWebSocketStrategy", () => {
        return new AblyWebSocketStrategy();
    });
})();
